import React from 'react'
import Image from 'next/image'
import { imageLoader } from '../../context/utils'
import { IArticleHead } from '../../interfaces/article'
import ReadButton from './readBtn.component'
import ThumbnailLead from './thumbnailLead.component'
import ThumbnailTitle from './thumbnailTitle.component'
import Link from 'next/link'
import { urlObjectFactoryForPagesWithSlug, urlObjectFactoryForWebmenus } from '../../utils/webmenus'
import { useAppContext } from '../../context/siteMapContext'
import { isRelatedArticleWithoutSlug, IWebMenu, WebMenuTypeEnum } from '../../interfaces/webMenu'

interface IArticleThumbnailProps {
  articleHead: IArticleHead
  isRelatedArticle: boolean
}

const ArticleThumbnail: React.FC<IArticleThumbnailProps> = ({
  articleHead,
  isRelatedArticle
}) => {
  const { coverImage, lead, title, date, showLastChangeDate } = articleHead
  const { webmenus, highContrastOn } = useAppContext()
  const webmenu = webmenus[articleHead.heading];

  const { urlObject, asPath } = generateLink(webmenu, isRelatedArticle, articleHead);
  return (
    <Link href={urlObject} as={asPath} shallow>
      <a>
        <div className='gap-[12px] xl:gap-[22px] flex flex-row h-auto xl:h-article-thumbnail pt-[40px] md:pt-[0px] md:mb-[40px] text-thumbnail 2xl:text-thumbnail-2xl'>
          {!!coverImage && (
            <div className='w-[50%] sm:w-full xl:w-3/8  xl:h-full block relative'>
              <Image
                loader={imageLoader}
                src={
                  typeof coverImage === 'string'
                    ? coverImage
                    : coverImage.fileThumbUrl
                }
                alt={coverImage?.title}
                title={coverImage?.title}
                layout='fill'
                objectFit='contain'
                tabIndex={0}
              />
            </div>
          )}

          <div className='w-full xl:w-5/8 xl:h-full xl:pl-10 flex flex-col justify-between'>
            <div className={`${highContrastOn ? 'text-white' : 'text-black'} font-montserrat`}>
              <ThumbnailTitle title={title} />
              <ThumbnailLead lead={lead} />
            </div>
            <div className='hidden sm:block'>
              <div className='w-full h-16 flex justify-between items-center mt-4'>
                <div className='font-montserrat font-medium w-[132px] h-full text-thumbnail-2xl invisible sm:visible'>
                  <span className='flex justify-center items-center h-full w-full text-white font-montserrat bg-read-me-btn-color' style={{ backgroundColor: highContrastOn ? 'white' : '' }} >
                    <div className={`${highContrastOn ? 'text-black bg-white' : 'text-white'}`}>
                      Megtekintem
                    </div>
                  </span>
                </div>
                {showLastChangeDate && <p className='hidden xl:inline-block white-space-nowrap'>Frissítve: {date}</p>}
              </div>
            </div>
          </div>
        </div>
      </a>
    </Link >
  )
}

//itt az /article hardocedolva volt/van TODO

function generateLink(webmenu: IWebMenu, isRelatedArticle: boolean, articleHead: IArticleHead) {
  //az akadálymentesítési nyilatkozat is lehet related article, viszont article típus alapból
  if (articleHead?.type == WebMenuTypeEnum.ACCESSIBILITYSTATEMENT) {
    webmenu.type = WebMenuTypeEnum.ACCESSIBILITYSTATEMENT;
  }
  if (isRelatedArticleWithoutSlug(webmenu.type) && isRelatedArticle) {
    const withoutSlug = urlObjectFactoryForWebmenus(
      webmenu
    );
    return {
      urlObject: withoutSlug.urlObject,
      asPath: withoutSlug.asPath
    }
  }
  const withSlug = urlObjectFactoryForPagesWithSlug(
    '/article',
    articleHead,
    webmenu
  )
  return {
    urlObject: withSlug.urlObject,
    asPath: withSlug.asPath
  }
}

export default ArticleThumbnail
